import { render, staticRenderFns } from "./StudentNoteForm.vue?vue&type=template&id=6271cb8b&scoped=true"
import script from "./StudentNoteForm.vue?vue&type=script&lang=js"
export * from "./StudentNoteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6271cb8b",
  null
  
)

export default component.exports